export default {
  "pressable": "_pressable_19ky1_1",
  "withFocusRing": "_withFocusRing_19ky1_5"
};import "ni:sha-256;la9jkmqqxGpxXuwai5syc8qOMkq8g-3bGQKykygkdvI";